import React, { useEffect, useRef } from "react";

import { useLocation } from "react-router-dom";

/**
 * DockContent is the page's scroll container (mounted above the router), so
 * a scrolled page would otherwise carry its offset onto the next route.
 * Rendered as DockContent's first child; scrolls its parent on navigation.
 */
export const DockScrollReset = () => {
  const { pathname } = useLocation();
  const marker = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    marker.current?.parentElement?.scrollTo?.(0, 0);
  }, [pathname]);

  return <div ref={marker} />;
};
